import React, { useState, useEffect } from 'react';
import api from '../services/api';
import Pagination from '../components/Pagination';
import { formatDateTime } from '../utils/date';

export default function Audit() {
  const [logs, setLogs] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState('');
  const [event, setEvent] = useState('');

  useEffect(() => { loadLogs(); }, [page, search, event]);
  async function loadLogs() {
    const { data } = await api.get('/audit', { params: { page, search: search || undefined, event: event || undefined } });
    setLogs(data.data); setTotal(data.total);
  }

  return (
    <div>
      <div className="flex items-center justify-between mb-6"><h1 className="text-xl font-bold tracking-tight">Auditoria</h1></div>
      <div className="bg-surface-100 border rounded-md p-4">
        <div className="flex gap-3 mb-4">
          <input className="form-input flex-1" placeholder="Buscar..." value={search}
            onChange={(e) => { setSearch(e.target.value); setPage(1); }} />
          <select className="form-select w-52" value={event} onChange={(e) => { setEvent(e.target.value); setPage(1); }}>
            <option value="">Todos os eventos</option>
            <option value="document_created">Documento criado</option>
            <option value="document_updated">Documento atualizado</option>
            <option value="document_deleted">Documento excluido</option>
            <option value="sent_to_review">Enviado para revisão</option>
            <option value="review_completed">Revisão concluída</option>
            <option value="sent_to_approval">Enviado para aprovação</option>
            <option value="document_approved_final">Aprovação final</option>
            <option value="document_rejected">Rejeitado</option>
          </select>
        </div>
        <table className="w-full border-collapse">
          <thead><tr className="border-b">
            <th className="text-left text-2xs font-semibold text-ink-muted uppercase px-3 py-2">Data</th>
            <th className="text-left text-2xs font-semibold text-ink-muted uppercase px-3 py-2">Evento</th>
            <th className="text-left text-2xs font-semibold text-ink-muted uppercase px-3 py-2">Descrição</th>
            <th className="text-left text-2xs font-semibold text-ink-muted uppercase px-3 py-2">Usuário</th>
            <th className="text-left text-2xs font-semibold text-ink-muted uppercase px-3 py-2">Detalhes</th>
          </tr></thead>
          <tbody>
            {logs.map((log) => (
              <tr key={log.id} className="border-b border-subtle hover:bg-surface-inset">
                <td className="px-3 py-3 text-xs font-mono whitespace-nowrap">{formatDateTime(log.created_at)}</td>
                <td className="px-3 py-3"><span className="doc-code">{log.event}</span></td>
                <td className="px-3 py-3 text-sm">{log.description}</td>
                <td className="px-3 py-3 text-sm">{log.causer_name || '—'}
                  {log.causer_email && <div className="text-xs text-ink-muted">{log.causer_email}</div>}
                </td>
                <td className="px-3 py-3 text-xs max-w-[200px] overflow-hidden text-ellipsis">
                  {log.properties ? JSON.stringify(log.properties) : '—'}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <Pagination page={page} total={total} limit={50} onPageChange={setPage} />
      </div>
    </div>
  );
}
